import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function _ContactMeta(props) { return <LabelValue {...props} value={props.content} /> }
const ContactMeta = withLabelTokenParsing(_ContactMeta, (props, keyword, options) => {
    const data = props.data || {};
    const address = data.ConsignerConsigneeAddress || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Address.Country:
            if (address && !Utilities.isNullOrWhitespace(address.Country)) {
                replaceString = Token.getReplacementString(address.Country, options);
            }
            break;
        case Token.Address.Line1:
            if (address && !Utilities.isNullOrWhitespace(address.LineOne)) {
                replaceString = Token.getReplacementString(address.LineOne, options);
            }
            break;
        case Token.Address.Line2:
            if (address && !Utilities.isNullOrWhitespace(address.LineTwo)) {
                replaceString = Token.getReplacementString(address.LineTwo, options);
            }
            break;
        case Token.Address.Location:
            if (address && !Utilities.isNullOrWhitespace(address.LocationWithZip)) {
                replaceString = Token.getReplacementString(address.LocationWithZip, options);
            }
            break;
        case Token.Email:
            if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeEmail)) {
                replaceString = Token.getReplacementString(data.ConsignerConsigneeEmail, options);
            }
            break;
        case Token.Name:
            if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeName)) {
                replaceString = Token.getReplacementString(data.ConsignerConsigneeName, options);
            }
            break;
        case Token.Phone.Default:
            if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneePhone)) {
                replaceString = Token.getReplacementString(data.ConsignerConsigneePhone, options);
            }
            break;
        case Token.SpouseName:
            if (!Utilities.isNullOrWhitespace(data.ConsignerConsigneeSpouseName)) {
                replaceString = Token.getReplacementString(data.ConsignerConsigneeSpouseName, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
}
);
const Tokens = () => [
    Token.getWrappedTokenConfig('Consigner Name', Token.Name),
    Token.getWrappedTokenConfig('Spouse Name', Token.SpouseName),
    Token.getWrappedTokenConfig('Address Line 1', Token.Address.Line1),
    Token.getWrappedTokenConfig('Address Line 2', Token.Address.Line2),
    Token.getWrappedTokenConfig('Location', Token.Address.Location),
    Token.getWrappedTokenConfig('Country', Token.Address.Country),
    Token.getWrappedTokenConfig('Phone', Token.Phone.Default),
    Token.getWrappedTokenConfig('Email', Token.Email)
];
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(1),
        description: LabelValueTypeConfig.panel.description,
        label: LabelValueTypeConfig.panel.label,
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(`${Utilities.wrapTextForEditor({ text: `{${Token.Name}("before":"","after":"")}`, token: Token.Name })}${Utilities.wrapTextForEditor({ text: `{${Token.SpouseName}("before":"","after":"")}`, token: Token.SpouseName })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line1}("before":"","after":"")}`, token: Token.Address.Line1 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Line2}("before":"","after":"")}`, token: Token.Address.Line2 })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Location}("before":"","after":"")}`, token: Token.Address.Location })}${Utilities.wrapTextForEditor({ text: `{${Token.Address.Country}("before":"","after":"")}`, token: Token.Address.Country })}${Utilities.wrapTextForEditor({ text: `{${Token.Phone.Default}("before":"","after":"")}`, token: Token.Phone.Default })}${Utilities.wrapTextForEditor({ text: `{${Token.Email}("before":"","after":"")}`, token: Token.Email })}`),
    }
};

export {
    ContactMeta as Component,
    Tokens,
    TypeConfig
};